import { foldersDeletableItemDisplayText } from 'ui/indexPages/modals/DeleteItemsModal/constants';
import {
  DeletableItemDisplayText,
  DeletableItem,
} from 'ui/indexPages/modals/DeleteItemsModal/types';

export type CustomBulkDeletionMixedActionWarningProps = {
  displayTextForContentItems: DeletableItemDisplayText;
  content: (DeletableItem & { workflowType: string })[];
  folders: DeletableItem[];
};

export const CustomBulkDeletionMixedActionWarning = ({
  content,
  folders,
  displayTextForContentItems,
}: CustomBulkDeletionMixedActionWarningProps) => {
  const folderOrFolders =
    foldersDeletableItemDisplayText.itemTypeName[folders.length > 1 ? 'plural' : 'singular'];
  const contentTypeName =
    displayTextForContentItems.itemTypeName[
      content.filter(({ workflowType }) => !workflowType || workflowType !== 'Draft').length > 1
        ? 'plural'
        : 'singular'
    ];
  const foldersDeletionAdjective = foldersDeletableItemDisplayText.actionName.adjective;
  const contentDeletionAdjective = displayTextForContentItems.actionName.adjective;

  const draftOrDrafts =
    content.filter(({ workflowType }) => workflowType === 'Draft').length > 1 ? 'drafts' : 'draft';

  return (
    <>
      (The {folderOrFolders} and {draftOrDrafts} will be permanently {foldersDeletionAdjective}, and
      the {contentTypeName} will be {contentDeletionAdjective}.)
    </>
  );
};
